import { formatter } from "./formatter";

export const promotion = {
	defaultName: "Cópia de {{promotion}}",
	errors: {
		nameLength: "O nome da promoção não atingiu a quantidade mínima de caracteres.",
		sameName: "O nome da cópia é igual ao nome original.",
		notFilledCorrectly: "Os campos não foram preenchidos corretamente.",
	},
	copyModal: {
		okText: "Copiar",
		title: "Criar cópia de promoção",
		message: "Deseja criar cópia da promoção",
		placeholder: "Nome da cópia de promoção",
	},
	peopleTable: {
		example: "planilha exemplo",
		error: "Formato inválido",
		import: "Importar planilha",
		download: "Baixar planilha exemplo",
	},
	categoryModal: {
		title: "Adicionar novo produto",
		suggestedTitle: "Adicionar produto sugerido",
		mainTitle: "Adicione o produto principal",
		label: "Produto ou categoria",
		placeholder: "Busque por um produto ou categoria",
		searchPlaceholder: "Buscar por produto",
		categoriesTitle: "Categorias",
		allCategories: "Todas as categorias ({{count}})",
		selectedCount: "{{count}} produtos selecionados",
		confirm: "Adicionar produto",
		noneProduct: "Nenhum produto encontrado",
	},
	creationStep: {
		formatter,
		error: "Não foi possível redirecionar página.",
		steps: {
			promotionInfo: "Dados da promoção",
			goals: "Metas",
			awards: "Prêmios",
			usageConditions: "Condições de uso",
			resume: "Resumo",
		},
		stepsPages: {
			goals: {
				tableWarningMessage: "Informação não disponível para Mesas.",
				label: "Recorrência de ganhos",
				placeholder: "Selecione uma recorrência máxima de ganhos",
				error: "Condição TODOS OS CLIENTES precisa ser removida",
				new: "Nova meta",
				add: "Adicionar meta",
				goalTypeTitle: "Selecione o tipo de meta",
				fichaCombineInfo:
					"Para combinar tipos de promoção Ficha no mesmo evento, crie promoções separadas",
				frequencyInfo:
					"Define com que frequência o cliente identificado pode ganhar a promoção.",
				buyAndEarn: {
					minQuantityLabel: "Quantidade mínima de consumo",
					minQuantityInfo:
						"Defina quantos produtos o cliente deve comprar para ganhar a promoção.",
					productLabel: "Adicione o produto da promoção",
					productInfo: "Selecione os produtos que participam da promoção.",
					addProducts: "adicionar produtos",
				},
				conditions: {
					birthday: {
						month: "Aniversariante do mês",
						week: "Aniversariante da semana",
						day: "Aniversariante do dia",
					},
					checkin: {
						label: "Horário de chegada",
					},
					gender: {
						male: "Homens",
						female: "Mulheres",
						others: "Outros",
					},
					minimumRecharge: {
						label: "Valor mínimo da recarga",
					},
				},
			},
			usageConditions: {
				conditions: {
					expiration: {
						label: "Dias corridos:",
						suffix: "Dias",
					},
					period: {
						beginTime: "De",
						endTime: "Até",
						error: "Hora no formato inválido para a conversão",
					},
					week: {
						infoText:
							"Como os eventos podem começar num dia da semana e terminar no outro, a promoção é válida no dia que o evento é iniciado. Então, o cliente pode usar a promoção no dia seguinte, caso o evento tenha sido iniciado no dia anterior.",
						validPromotion: "Promoção válida ",
					},
					modal: {
						new: "Nova condição de uso",
						add: "Adicionar condição de uso",
					},
				},
				totem: {
					usageLimitTitle: "Limite de uso",
					usageLimitDescription:
						"Defina um limite máximo de vezes que a promoção pode ser utilizada",
					usageLimitUnlimited: "Ilimitado",
					usageLimitWithLimit: "Com limite",
					usageLimitPlaceholder: "Defina o limite de usos",
					usageLimitAlertTitle: "Dependência de conexão com a internet",
					usageLimitAlertMessage:
						"Ao definir limite de usos, essa promoção dependerá de conexão com a internet no PDV. Promoções ilimitadas funcionam offline.",
					expirationTitle: "Expiração pós ganho (opcional)",
					expirationDescription:
						"Defina quanto tempo o cliente terá para aproveitar a promoção",
					expirationPlaceholder: "Defina o tempo de expiração em dias corridos",
					importantTitle: "Importante",
					importantBuyAndEarn:
						"As condições de uso para 'Compre e Ganhe' também são usadas para ganhar a promoção.",
					importantExpiration:
						"Expiração pós-ganho não se aplica para o 'Compre e Ganhe'.",
					weekDaysTitle: "Dias da semana",
					weekDaysDescription:
						"Defina que dias da semana o cliente pode utilizar a promoção.",
					periodTitle: "Dias e horário de uso",
					periodDescription:
						"Defina a faixa de horário e/ou dias da semana que os clientes poderão utilizar a promoção",
				},
			},
		},
		stepsWrapper: {
			title: "Título não encontrado",
			description: "Descrição não encontrada",
			save: "Salvar alterações",
			saveAndPublish: "Salvar e publicar",
			discard: "Descartar alterações",
		},
	},
	table: {
		goals: {
			label: "Lista de metas da promoção",
			empty: "Nenhuma meta",
			new: "Nova meta",
		},
		usageConditions: {
			label: "Lista de condições de uso da promoção",
			empty: "Nenhuma condição de uso",
			new: "Nova condição de uso",
		},
	},
};
